module.exports = ":host {\n  display: block; }\n  :host .checkbox label {\n    white-space: normal; }\n  .checkbox label {\n  font-weight: normal;\n  color: #888;\n  font-size: inherit;\n  padding-left: 30px !important;\n  font-family: inherit; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/forms/elements/components/input/input.component.scss
// module id = ./libs/chassis-core/src/app/forms/elements/components/input/input.component.scss
// module chunks = main